import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIFilterFormContext} from "./filter-form-context";

@Component({
    selector: "fui-filter-form-context",
    template: "<ng-content></ng-content>",
    providers: [{provide: FUIFormContext, useClass: FUIFilterFormContext}]
})
export class FUIFilterFormContextComponent {
}
